<template>
  <div
    class="sub-gnb-text flex flex-space-between flex-align-center"
    :class="{ 'flex-row-reverse': !visibleImage }"
  >
    <nuxt-img
      v-if="visibleImage"
      class="ml-16"
      src="/icons/outline/chevron-left.svg"
      height="24"
      width="24"
      alt="back"
      @click="routeBack"
    />
    <nuxt-link
      v-if="textLink"
      class="text-link mr-16"
      :class="customTextLink"
      :to="gnbData?.url"
    >
      {{ gnbData?.text }}
    </nuxt-link>
    <el-link
      v-if="buttonTextLink"
      class="text mr-16"
      :underline="false"
      @click="() => $emit('click-text')"
    >
      {{ gnbData?.text }}
    </el-link>
  </div>
</template>

<script setup lang="ts">
const { navigate } = useCommon()
const { options, back } = useRouter()

const props = withDefaults(
  defineProps<{
    partnersKey?: string
    visibleImage?: boolean
    gnbData?: GnbData
    textLink?: boolean
    customTextLink?: string
    buttonTextLink?: boolean
  }>(),
  {
    partnersKey: '',
    visibleImage: true,
    gnbData: undefined,
    textLink: true,
    customTextLink: '',
    buttonTextLink: false
  }
)

defineEmits(['click-text'])

const routeBack = () => {
  const historyUrl = String(options.history.state.back)
  switch (historyUrl) {
    case 'null':
      navigate('/', props.partnersKey)
      break
    default:
      historyUrl.includes('/user/refund/refund-success') || historyUrl.includes('/user/login')
        ? navigate('/', props.partnersKey)
        : back()
      break
  }
}
</script>
